import serializeSchedulePoint from './serializeSchedulePoint';

const getOfficeSchedule = (office, schedules) => {
  const officeSchedule = schedules.find(
    schedule => `${office.workScheduleId}` === `${schedule.id}`
  );

  return serializeSchedulePoint(officeSchedule.records);
};

export default getOfficeSchedule;
